



























































































import { GameResultService } from '@/services/game/result'
import { PluginMixin } from '@spa/mixins/plugin'
import Vue, { VueConstructor } from 'vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class GameResult extends Mixins<PluginMixin>(PluginMixin) {
  couponImageUrl: string = ''
  styleHtml: string = ''
  scriptHtml: string = ''
  isError: boolean = false

  freeContentVue: VueConstructor = Vue.extend({
    template: '<div></div>',
  })

  @Prop({ default: '' })
  brandEnglishName: string

  @Prop({ required: true })
  campaignId: string

  async created() {

    const gameResultService =
      GameResultService.build(this.campaignId, this.brandEnglishName)

    const pageParts = await gameResultService.tryToGetPageParts().catch(() => {

      this.isError = true

      if (typeof document !== 'undefined') {
        document.body.classList.add('error')
      }
    })

    // リダイレクト時はpagePartsがundefinedとなる
    if (pageParts) {
      this.couponImageUrl = pageParts.couponImageUrl

      this.freeContentVue = Vue.extend({
        // vue のtemplateのrootは必ず1つの要素
        template: `<div>${ pageParts.freeContentHtml }</div>`,
      })
      this.scriptHtml = pageParts.freeContentScript
      this.styleHtml = pageParts.freeContentStyle
    }
  }

  get topUrlWithBrandNameContext(): string {
    return `/${ this.brandEnglishName }`
  }
}
